import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './ToCartPopup.scss';
import stylesAuthPopup from '../../styles/AuthPopup.scss';
import ToCartTable from './elements/ToCartTable';
import config from 'src/config';
import {declinationByNumber} from 'src/logic/utils';

export default function ToCartPopup (props) {
  if (!props.isOpen) {
    return null;
  }

  const {
    foundDetail,
    foundDetailOffers,
    chosenOfferId,
    toCartQuantity,
    partnerId,
    addItemToCart,
    toCartPopupComment,
    changeToCartComment} = props;

  const chosenOffer = foundDetailOffers.filter(offer => +offer.offerId == +chosenOfferId)[0];
  const count = props.cartItems.length;

  return (
    <div>
      <div
        className={stylesAuthPopup.backDrop} />
        <div className={stylesAuthPopup.popupWindowToCart}>
          <div
            onClick={props.closeToCartPopup}
            className={stylesAuthPopup.closeBtn} />
          <div className={stylesAuthPopup.header}>
            Добавление товара в корзину
          </div>
          <span style={{marginLeft: '-5px'}}>
            Всего в вашей корзине {count} {declinationByNumber(count, ['товар','товара','товаров'])}. <a
            className="link"
            href={config.routes.cart}>Посмотреть</a>
          </span>
          <ToCartTable {...props}/>
          <input
            className={styles.searchInput}
            placeholder="Комментарий к заказу"
            type="text"
            onChange={(e) => changeToCartComment(e.target.value)}/>
          <div className={styles.submit_container}>
            <button className={styles.searchBtn} onClick={
              () => {
                addItemToCart({
                    cartDetailId: count,
                    quantity: toCartQuantity,
                    price: chosenOffer.price,
                    name: foundDetail.name,
                    detailNum: foundDetail.detailNum,
                    supplier: chosenOffer.supplier,
                    offerId: chosenOfferId,
                    partnerId: partnerId,
                    comment: toCartPopupComment
                   });
                }}>В корзину</button>
          </div>
        </div>
    </div>
  );
}

ToCartPopup.propTypes = {
  closeToCartPopup: PropTypes.func
};



/** WEBPACK FOOTER **
 ** ./src/components/ToCartPopup/ToCartPopup.jsx
 **/